export default {"src":"/pro/_next/static/media/sol.5c652667.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};